module.exports = __webpack_public_path__ + "img/image_signing05@2x.960045e9.png";